module.exports = __webpack_public_path__ + "static/img/logo-brilhar-site.2560136.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-brilhar-site.png
// module id = 129
// module chunks = 17